export default __webpack_public_path__ + "static/media/TRKR-Login-Process-Icons-15.55849a2b.png";